'use client';

import { Show } from '@/components/conditional-component';
import { ArrowLeft, Clock2 } from 'lucide-react';
import Link from 'next/link';
export function BatchHeader({
  daysLeft,
  isExpired
}: {
  daysLeft: number;
  isExpired: boolean;
}) {
  const isAddmissionClosingSoon = daysLeft <= 4;
  return <header className="w-full border-b bg-white " data-sentry-component="BatchHeader" data-sentry-source-file="batch-header.tsx">
      <div className="container flex w-full items-center gap-2 p-2 md:justify-normal">
        <Link href="/batchfinder" className="flex items-center gap-2 p-2 " data-sentry-element="Link" data-sentry-source-file="batch-header.tsx">
          <ArrowLeft className="size-4" data-sentry-element="ArrowLeft" data-sentry-source-file="batch-header.tsx" />
        </Link>
        <Show when={isAddmissionClosingSoon && !isExpired} data-sentry-element="Show" data-sentry-source-file="batch-header.tsx">
          <span className="text-sm font-semibold md:text-lg">Admission closing soon...</span>
          <div className="flex flex-1 justify-end md:justify-normal">
            <div className="flex  items-center gap-1  rounded bg-[#F4EEE6] p-1  text-xs font-semibold text-[#DE5207]">
              <Clock2 className="size-4" data-sentry-element="Clock2" data-sentry-source-file="batch-header.tsx" />
              <span className="flex w-full">
                {daysLeft}
                {' '}
                Days
              </span>
            </div>
          </div>
        </Show>
      </div>
    </header>;
}